module.exports = __webpack_public_path__ + "img/97.616d0a54.png";